import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarDespesaLayer from "../components/CadastrarDespesaLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarDespesaPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("despesa.breadcrumb.create")} />
      <CadastrarDespesaLayer />
    </MasterLayout>
  );
};

export default CadastrarDespesaPage;
